import { placeTypesStrings } from '@/lib/place'

let placeTypeString = {
  install: (app, options) => {
    app.config.globalProperties.$placeTypeString = placeTypesStrings
    app.provide('placeTypesStrings', placeTypesStrings)
    console.log('placeTypesStrings', placeTypesStrings)
  }
}


export default placeTypeString
